// eslint-disable no-use-before-define
// eslint-disable react/prop-types
import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import { Link as RouterLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PerfectScrollbar from 'react-perfect-scrollbar';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Divider,
  Drawer,
  Hidden,
  Link,
  List,
  ListSubheader,
  Typography,
  Button,
  makeStyles
} from '@material-ui/core';
import {
  Users as UsersIcon,
  Settings as SettingsIcon,
  Map as MapIcon,
  BarChart2,
  File,
  Calendar,
  Home,
  Search
} from 'react-feather';
import Logo from 'src/components/Logo';
import NavItem from './NavItem';
import {
  Assignment,
  CropFree,
  Group,
  PinDrop,
  // Search,
  ShoppingBasket
} from '@material-ui/icons';

function renderNavItems({ items, ...rest }) {
  return (
    <List disablePadding>
      {items.reduce(
        (acc, item) => reduceChildRoutes({ acc, item, ...rest }),
        []
      )}
    </List>
  );
}

function reduceChildRoutes({ acc, item, depth = 0 }) {
  const key = item.title + depth;
  acc.push(
    <NavItem
      style={{
        display:
          item.owner === item.currentrole
            ? 'block'
            : item.owner === 'all'
            ? 'block'
            : 'none'
      }}
      depth={depth}
      href={item.href}
      icon={item.icon}
      key={key}
      info={item.info}
      title={item.title}
      enabled={item.enabled}
    />
  );

  return acc;
}

const imageLocation = process.env.REACT_APP_IMAGE;

const useStyles = makeStyles(() => ({
  mobileDrawer: {
    width: 256
  },
  desktopDrawer: {
    width: 256,
    top: 64,
    height: 'calc(100% - 64px)'
  },
  avatar: {
    cursor: 'pointer',
    width: 120,
    height: 120
  }
}));

function NavBar({ openMobile, onMobileClose }) {
  const classes = useStyles();
  const location = useLocation();
  const { user } = useSelector(state => state.account);
  const navConfig = [
    //SYSTEM ADMIN
    {
      subheader: '',
      owner: 'admin',
      items: [
        {
          title: 'Dashboard',
          icon: Home,
          href: '/alagang-abc/dashboard',
          enabled: true
        },
        {
          title: 'Beneficiaries',
          icon: UsersIcon,
          href: '/alagang-abc/beneficiaries',
          enabled: true
        },
        {
          title: 'Comelec Voters',
          icon: UsersIcon,
          href: '/alagang-abc/comelec-voters',
          enabled: true
        },
        {
          title: 'QR Scanner',
          icon: CropFree,
          href: '/alagang-abc/qr-scanner',
          enabled: true
        },
        {
          title: 'Expense',
          icon: BarChart2,
          href: '/alagang-abc/expense',
          enabled: true
        },
        {
          title: 'Payout',
          icon: ShoppingBasket,
          href: '/alagang-abc/payout',
          enabled: true
        },
        {
          title: 'Configs',
          icon: SettingsIcon,
          href: '/alagang-abc/configs',
          enabled: true
        },
        {
          title: 'Map',
          icon: MapIcon,
          href: '/alagang-abc/map',
          enabled: true
        },
        {
          title: 'Report',
          icon: File,
          href: '/alagang-abc/report',
          enabled: true
        },
        {
          title: 'Birthdays',
          icon: Calendar,
          href: '/alagang-abc/birthdays',
          enabled: true
        },
        {
          title: 'Election Poll',
          icon: Assignment,
          href: '/alagang-abc/events',
          enabled: true
        },
        {
          title: 'Users',
          icon: Group,
          href: '/alagang-abc/users',
          enabled: true
        },
        {
          title: 'Quick Count',
          icon: Search,
          href: '/alagang-abc/quick-count',
          enabled: true
        },
        {
          title: 'Heat Map',
          icon: PinDrop,
          href: '/alagang-abc/heat-map',
          enabled: true
        }
      ]
    },
    //FRONT DESK
    {
      subheader: '',
      owner: 'front desk',
      items: [
        {
          title: 'Voters',
          icon: UsersIcon,
          href: '/alagang-abc/front-desk/voters',
          enabled: true
        }
      ]
    },
    //POLL WATCHER
    {
      subheader: '',
      owner: 'poll watcher',
      items: [
        {
          title: 'Report',
          icon: UsersIcon,
          href: '/alagang-abc/poll-watcher/report',
          enabled: true
        }
      ]
    },
    //DOC TRACK
    {
      subheader: '',
      owner: 'doc track',
      items: [
        {
          title: 'Dashboard',
          icon: File,
          href: '/alagang-abc/receiver/documents',
          enabled: true
        }
      ]
    },
    //DOC TRACK ADMIN
    {
      subheader: '',
      owner: 'doc track admin',
      items: [
        {
          title: 'Dashboard',
          icon: File,
          href: '/alagang-abc/doc-track-admin/documents',
          enabled: true
        }
      ]
    }
  ];

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  const content = (
    <Box height="100%" display="flex" flexDirection="column">
      <PerfectScrollbar options={{ suppressScrollX: true }}>
        <Hidden lgUp>
          <Box p={2} display="flex" justifyContent="center">
            <RouterLink to="/">
              <Logo />
            </RouterLink>
          </Box>
        </Hidden>
        <Box p={2}>
          <Box display="flex" justifyContent="center">
            <RouterLink to="/app/account">
              <Avatar
                alt="User"
                className={classes.avatar}
                src={`${imageLocation}avatar/${user.avatar}`}
              />
            </RouterLink>
          </Box>
          <Box mt={2} textAlign="center">
            <Link
              component={RouterLink}
              to="/app/account"
              variant="h5"
              color="textPrimary"
              underline="none"
            >
              {`${user.firstname} ${user.lastname}`}
            </Link>
            <Typography variant="body2" color="textSecondary">
              {user.phone}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {user.state}
            </Typography>
            {/* <Typography variant="body2" color="textSecondary">
              {user.bio}
            </Typography> */}
          </Box>
        </Box>
        <Divider />
        <Box p={2}>
          {navConfig
            .filter(x => user.roles[0].name.trim() === x.owner)
            .map((config, index) => (
              <List
                key={index}
                subheader={
                  <ListSubheader disableGutters disableSticky>
                    {config.subheader}
                  </ListSubheader>
                }
              >
                {renderNavItems({
                  items: config.items,
                  pathname: location.pathname
                })}
              </List>
            ))}
        </Box>
        <Divider />
        <Hidden xsUp xsDown>
          <Box p={1}>
            <Box p={2} borderRadius="borderRadius" bgcolor="background.dark">
              <Typography variant="h6" color="textSecondary" align="center">
                To register your property? Click
              </Typography>

              <Box mt={1}>
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  component={RouterLink}
                  to="/app/property/register"
                  fullWidth
                >
                  Register
                </Button>
              </Box>
            </Box>
          </Box>
        </Hidden>
      </PerfectScrollbar>
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
}

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

export default NavBar;
